module.exports = __webpack_public_path__ + "static/img/valkyrie_logo_head.18ae1e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/valkyrie_logo_head.png
// module id = W2+4
// module chunks = 1